
<div [formGroup]="form" class="make-responsive">
    <div class="mt-top-2 field">
        <mat-form-field>
            <mat-label>Address Line One</mat-label>
            <input matInput formControlName="lineOne" onkeypress="if(this.value.length===30)return false;">
        </mat-form-field>
    </div>
    <div class="mt-top-2 field">
        <mat-form-field>
            <mat-label>Address Line Two</mat-label>
            <input matInput formControlName="lineTwo" onkeypress="if(this.value.length===30)return false;">
        </mat-form-field>
    </div>
    <div class="mt-top-2 field">
        <mat-form-field>

            <mat-label>City</mat-label>
            <input matInput formControlName="city">
        </mat-form-field>
    </div>
    <div class="mt-top-2 field">
        <mat-form-field>
            <mat-label>State</mat-label>
            <input matInput formControlName="state">
        </mat-form-field>
    </div>
    <div class="mt-top-2 field">
        <mat-form-field>
            <mat-label>Postal Code</mat-label>
            <input matInput formControlName="postalCode">
        </mat-form-field>
    </div>
    <div class="mt-top-2 field">
        <mat-form-field>
            <mat-label>Country</mat-label>
            <input matInput formControlName="country">
        </mat-form-field>
    </div>
</div>